import useApiPrivateClient from "../../hooks/useApiPrivateClient";
import { CreateSponsorData, UpdateSponsorData } from "./sponsor.requests";
import { Sponsor } from "./sponsor.responses";

const useSponsorService = () => {
  const apiPrivateClient = useApiPrivateClient();

  const createSponsor = (sponsorData: CreateSponsorData) => {
    return apiPrivateClient.post<Sponsor>("/sponsors", sponsorData);
  };

  const getSponsors = () => {
    return apiPrivateClient.get<Sponsor[]>("/sponsors");
  };

  const patchSponsor = (sponsorId: number, updateData: UpdateSponsorData) => {
    return apiPrivateClient.patch<Sponsor>(
      `/sponsors/${sponsorId}`,
      updateData
    );
  };

  const deleteSponsor = (sponsorId: number) => {
    return apiPrivateClient.patch<Sponsor>(`/sponsors/${sponsorId}`);
  };

  return {
    createSponsor,
    getSponsors,
    patchSponsor,
    deleteSponsor,
  };
};
export default useSponsorService;
